define('modules/page_listing/collections/tags',['require','exports','module','base/collection','../models/tag','env'],function(require, exports, module) {
  "use strict";

  var Collection = require("base/collection"),
      Tag = require("../models/tag"),
      config = require("env");

  module.exports = Collection.extend({
    model: Tag,
    url: function() {
      return config.apiHost + "/tags";
    },
    addTag: function(tag, options) {
    },
    removeTag: function() {
    },
    search: function(text) {
      var result = this.filter(function(tag){
        var tagText = tag.get("text").toLowerCase();
        text = text.trim().toLowerCase();
        return !!tagText.match(text);
      });
      // Hack for result array to be rendered as a collection
      result.each = _.bind(Array.prototype.forEach, result);
      return result;
    },
    searchTag: function(text) {
      return this.findWhere({text: text.trim()});
    },
    toQueryString: function(){
      return this.map(function(tagModel){ 
        return tagModel.get("text"); 
      }).join(",");
    }
  });
});

